import { render, staticRenderFns } from "./VsTable.vue?vue&type=template&id=478be7d8&"
import script from "./VsTable.vue?vue&type=script&lang=js&"
export * from "./VsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports